﻿import * as layerTypes from '../../../map/utils/layerTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import * as eventTypes from '../../../map/utils/eventTypes';
import * as styleTypes from '../../../map/utils/style/styleTypes';
import Draw, { createRegularPolygon } from 'ol/interaction/Draw';
import {
    Circle as CircleStyle,
    Fill,
    RegularShape,
    Stroke,
    Style,
    Text,
    Icon
} from 'ol/style.js';
import { LineString, Point } from 'ol/geom.js';
import { getArea, getLength } from 'ol/sphere.js';
import Feature from 'ol/Feature.js';
import { MouseWheelZoom } from 'ol/interaction';
import { primaryAction } from 'ol/events/condition';
export default class RedlineControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, toolbarContainer, snapOpts) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.toolbarContainer = toolbarContainer;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.drawPointId = 'draw-point-' + this.classId;
        this.drawTextId = 'draw-text-' + this.classId;
        this.drawLineId = 'draw-line-' + this.classId;
        this.drawPolygonId = 'draw-polygon-' + this.classId;
        this.drawSquareId = 'draw-square-' + this.classId;
        this.drawCircleId = 'draw-circle-' + this.classId;
        this.deleteRedlineId = 'delete-redline-' + this.classId;
        this.deleteAllRedlinesId = 'delete-all-redlines-' + this.classId;
        this.redlineOptionsId = 'redline-options-' + this.classId;
        this.symbolTypeId = 'symbol-type-' + this.classId;
        this.imageUrlId = 'image-url-' + this.classId;
        this.fillId = 'redline-fill-' + this.classId;
        this.lineTypeId = 'line-type-' + this.classId;
        this.strokeId = 'redline-stroke-' + this.classId;
        this.sizeId = 'redline-size-' + this.classId;
        this.eastingId = 'redline-easting-' + this.classId;
        this.northingId = 'redline-northing-' + this.classId
        this.angleId = 'redline-angle-' + this.classId;
        this.captureId = 'redline-capture-' + this.classId;
        this.colorId = 'redline-color-' + this.classId;
        this.textSizeId = 'redline-text-size-' + this.classId;
        this.haloColorId = 'redline-halo-color-' + this.classId;
        this.haloSizeId = 'redline-halo-size-' + this.classId;
        this.textId = 'redline-text-' + this.classId;
        this.finishId = 'redline-finish-' + this.classId;
        this.active = false;
        this.layerAdded = false;
        this.currentInteraction = null;
        this.currentDrawType = null;
        this.shiftPressed = false;
        this.deleteEnabled = false;
        this.lastPointFill = 'rgba(0, 0, 255, 1)';
        this.lastPointStroke = 'rgba(0, 0, 255, 1)';
        this.lastTextColor = 'rgba(0, 0, 0, 1)';
        this.lastTextHaloColor = 'rgba(255, 255, 255, 1)';
        this.lastLineStroke = 'rgba(0, 0, 255, 1)';
        this.lastPolygonStroke = 'rgba(0, 0, 255, 1)';
        this.lastPolygonFill = 'rgba(0, 0, 255, 1)';
        this.lastSquareStroke = 'rgba(0, 0, 255, 1)';
        this.lastSquareFill = 'rgba(0, 0, 255, 1)';
        this.lastCircleStroke = 'rgba(0, 0, 255, 1)';
        this.lastCircleFill = 'rgba(0, 0, 255, 1)';
        this.currentId = 1;
        this.iconStyleCache = new Map();

        this.keydownEvent = (evt) => {
            if (evt.keyCode == 27) {
                this._stopDraw();
            }
        };

        this._initDrawStyle();
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        $event.register(eventTypes.USER_INTERACTION_STARTED, this._getUserInteractionStartedHandler(), this, this.classId);
        $event.register(eventTypes.MAP_POINTER_MOVE, this._getUserMapPointerMoveHandler(), this, this.classId);
        $event.register(eventTypes.MAP_POINTER_CLICK, this._getUserMapPointerClickHandler(), this, this.classId);
        $event.register(eventTypes.RIGHT_CLICK, this._getUserMapRightClickHandler(), this, this.classId);
    }

    _memoizeIcon(src) {
        const cached = this.iconStyleCache.get(src);
        if (cached) return cached;

        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
            const finalStyle = new Icon({
                img,
                imgSize: [img.width, img.height]
            });
            this.iconStyleCache.set(src, finalStyle);
        };
        img.src = src;

        return null;
    }

    _stopDraw() {
        if (this.currentInteraction != null) {
            this.currentInteraction.abortDrawing();
        }
    }

    _getUserMapRightClickHandler() {
        var handler = (eventName, data, sender) => {
            this._stopDraw();
        };

        return handler;
    }

    _getUserMapPointerMoveHandler() {
        var handler = (eventName, data, sender) => {
            if (this.deleteEnabled) {
                if (data.originalEvent == null) {
                    return;
                }

                let pixel = this.mapControl.map.getEventPixel(data.originalEvent);

                if (pixel == null) {
                    return;
                }

                let options = {
                    layerFilter: (layer) => {
                        return layer.get("uid") == layerTypes.REDLINE;
                    }
                }

                var features = this.mapControl.map.getFeaturesAtPixel(pixel, options);

                if (features.length > 0) {
                    this.mapControl.map.getViewport().style.cursor = 'pointer';
                } else {
                    this.mapControl.map.getViewport().style.cursor = 'inherit';
                }
            }
        };

        return handler;
    }

    _getUserMapPointerClickHandler() {
        var handler = (eventName, data, sender) => {
            if (this.deleteEnabled) {
                if (data.originalEvent == null) {
                    return;
                }

                let pixel = this.mapControl.map.getEventPixel(data.originalEvent);

                if (pixel == null) {
                    return;
                }

                let options = {
                    layerFilter: (layer) => {
                        return layer.get("uid") == layerTypes.REDLINE;
                    }
                }

                var features = this.mapControl.map.getFeaturesAtPixel(pixel, options);

                if (features.length > 0) {
                    this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource().removeFeature(features[0]);
                }
            }
        };

        return handler;
    }

    _initDrawStyle() {
        this.drawMeasureStyle = new Style({
            fill: new Fill({
                color: 'rgba(255, 0, 0, 1)',
            }),
            stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                width: 3,
            }),
            image: new RegularShape({
                radius: 8,
                radius2: 1,
                points: 4,
                angle: 0,
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 1)',
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)',
                }),
            }),
        });

        this.drawLabelStyle = new Style({
            text: new Text({
                font: 'bold 14px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 0, 0, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._removeInteraction();
                this._hideToolbar();
            } else {
                $event.notify(eventTypes.USER_INTERACTION_STARTED, {}, this, this.classId);
                this._showToolbar();
            }
        };
    }

    _getUserInteractionStartedHandler() {
        var handler = (eventName, data, sender) => {
            this._removeInteraction();
            this._hideToolbar();
        };

        return handler;
    }

    _hideToolbar() {
        $('#' + this.elementId).removeClass('selected');
        this.active = false;
        this.toolbarContainer.innerHTML = '';
        this.mapControl.selectionHandler.isActive = true;
        document.removeEventListener('keydown', this.keydownEvent);
        $event.notify(eventTypes.DRAW_TOOLBAR_HIDDEN, {}, this, this.classId);
    }

    _showToolbar() {
        $('#' + this.elementId).addClass('selected');
        if (!this.layerAdded) {
            this._addRedlineLayer();
        }

        this.active = true;
        this.toolbarContainer.innerHTML = this._getToolbarTemplate();
        this.mapControl.map.getViewport().style.cursor = 'inherit';

        $('.feature-toolbar-extra-content').css('width', $('.header-options').width() + 'px');

        $('#' + this.drawPointId).on('click', () => {
            this._drawPoint();
        });

        $('#' + this.drawTextId).on('click', () => {
            this._drawText();
        });

        $('#' + this.drawLineId).on('click', () => {
            this._drawLine();
        });

        $('#' + this.drawPolygonId).on('click', () => {
            this._drawPolygon();
        });

        $('#' + this.drawSquareId).on('click', () => {
            this._drawSquare();
        });

        $('#' + this.drawCircleId).on('click', () => {
            this._drawCircle();
        });

        $('#' + this.deleteRedlineId).on('click', () => {
            this._deleteRedline();
        });

        $('#' + this.deleteAllRedlinesId).on('click', () => {
            this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource().clear();
        });

        document.addEventListener('keydown', this.keydownEvent);
        $event.notify(eventTypes.DRAW_TOOLBAR_VISIBLE, {}, this, this.classId);
    }

    _deleteRedline() {
        if ($('#' + this.deleteRedlineId).hasClass('active')) {
            $('#' + this.deleteRedlineId).removeClass('active');
            this.deleteEnabled = false;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.deleteRedlineId).addClass('active');
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#' + this.redlineOptionsId)[0].innerHTML = '';
            this._removeInteraction();
            this.deleteEnabled = true;
        }
    }

    _drawCircle() {
        if ($('#' + this.drawCircleId).hasClass('active')) {
            $('#' + this.drawCircleId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#' + this.redlineOptionsId)[0].innerHTML = '';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.drawCircleId).addClass('active');
            this._startDrawCircle();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _drawSquare() {
        if ($('#' + this.drawSquareId).hasClass('active')) {
            $('#' + this.drawSquareId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#' + this.redlineOptionsId)[0].innerHTML = '';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.drawSquareId).addClass('active');
            this._startDrawSquare();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _drawPolygon() {
        if ($('#' + this.drawPolygonId).hasClass('active')) {
            $('#' + this.drawPolygonId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#' + this.redlineOptionsId)[0].innerHTML = '';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.drawPolygonId).addClass('active');
            this._startDrawPolygon();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _drawLine() {
        if ($('#' + this.drawLineId).hasClass('active')) {
            $('#' + this.drawLineId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#' + this.redlineOptionsId)[0].innerHTML = '';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.drawLineId).addClass('active');
            this._startDrawLine();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _drawText() {
        if ($('#' + this.drawTextId).hasClass('active')) {
            $('#' + this.drawTextId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#' + this.redlineOptionsId)[0].innerHTML = '';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.drawTextId).addClass('active');
            this._startDrawText();
            this.mapControl.map.getViewport().style.cursor = 'none';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _drawPoint() {
        if ($('#' + this.drawPointId).hasClass('active')) {
            $('#' + this.drawPointId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            $('#' + this.redlineOptionsId)[0].innerHTML = '';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.drawPointId).addClass('active');
            this._startDrawPoint();
            this.mapControl.map.getViewport().style.cursor = 'none';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _startDrawCircle() {
        $('#' + this.redlineOptionsId)[0].innerHTML = this._getCircleOptions();

        let lineTypes = this._getLineTypes();

        $('#' + this.lineTypeId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: lineTypes
        });

        $('#' + this.lineTypeId).data('kendoComboBox').value(lineTypes[0].id);

        $('#' + this.fillId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastCircleFill = $('#' + this.fillId).data('kendoColorPicker').value()
            }
        });
        $('#' + this.strokeId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastCircleStroke = $('#' + this.strokeId).data('kendoColorPicker').value()
            }
        });

        $('#' + this.eastingId).kendoNumericTextBox();
        $('#' + this.northingId).kendoNumericTextBox();

        $('#' + this.sizeId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.sizeId).data('kendoNumericTextBox').value(2);

        this._removeInteraction();

        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource(),
            type: 'Circle',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Circle');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawstart', (evt) => {
            this.currentFeature = evt.feature;
        });

        this.currentInteraction.on('drawend', (evt) => {
            evt.feature.set('showLength', true);
            evt.feature.set('showAngle', true);
            evt.feature.set('labelUnits', 'M');
            evt.feature.set('drawType', 'Circle');
            evt.feature.set('lineType', $('#' + this.lineTypeId).data('kendoComboBox').value());
            evt.feature.set('strokeColor', $('#' + this.strokeId).data('kendoColorPicker').value());
            evt.feature.set('strokeSize', $('#' + this.sizeId).data('kendoNumericTextBox').value());
            evt.feature.set('fillColor', $('#' + this.fillId).data('kendoColorPicker').value());
            evt.feature.layerId = layerTypes.REDLINE;
            evt.feature.set('id', this.currentId);
            this.currentId++;
        });

        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Circle' }, this, this.mapControl.classId);
    }

    _startDrawSquare() {
        $('#' + this.redlineOptionsId)[0].innerHTML = this._getSquareOptions();

        let lineTypes = this._getLineTypes();

        $('#' + this.lineTypeId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: lineTypes
        });

        $('#' + this.lineTypeId).data('kendoComboBox').value(lineTypes[0].id);

        $('#' + this.fillId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastSquareFill = $('#' + this.fillId).data('kendoColorPicker').value()
            }
        });
        $('#' + this.strokeId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastSquareStroke = $('#' + this.strokeId).data('kendoColorPicker').value()
            }
        });

        $('#' + this.eastingId).kendoNumericTextBox();
        $('#' + this.northingId).kendoNumericTextBox();

        $('#' + this.sizeId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.sizeId).data('kendoNumericTextBox').value(2);

        this._removeInteraction();

        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource(),
            type: 'Circle',
            geometryFunction: createRegularPolygon(4),
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Polygon');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawstart', (evt) => {
            this.currentFeature = evt.feature;
        });

        this.currentInteraction.on('drawend', (evt) => {
            evt.feature.set('showLength', true);
            evt.feature.set('showAngle', true);
            evt.feature.set('labelUnits', 'M');
            evt.feature.set('drawType', 'Square');
            evt.feature.set('lineType', $('#' + this.lineTypeId).data('kendoComboBox').value());
            evt.feature.set('strokeColor', $('#' + this.strokeId).data('kendoColorPicker').value());
            evt.feature.set('strokeSize', $('#' + this.sizeId).data('kendoNumericTextBox').value());
            evt.feature.set('fillColor', $('#' + this.fillId).data('kendoColorPicker').value());
            evt.feature.layerId = layerTypes.REDLINE;
            evt.feature.set('id', this.currentId);
            this.currentId++;
        });

        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Circle' }, this, this.mapControl.classId);
    }

    _startDrawPolygon() {
        $('#' + this.redlineOptionsId)[0].innerHTML = this._getPolygonOptions();

        $('#' + this.captureId).on('click', () => {
            let easting = $('#' + this.eastingId).data('kendoNumericTextBox').value();
            let northing = $('#' + this.northingId).data('kendoNumericTextBox').value();
            if (this.currentInteraction.sketchFeature_) {
                this._addPointToPolygon([easting, northing]);
                this.currentInteraction.sketchCoords_ = this.currentFeature.getGeometry().getCoordinates();
            } else {
                this.currentInteraction.startDrawing_([easting, northing]);
            }
        });

        $('#' + this.finishId).on('click', () => {
            this.currentInteraction.finishDrawing();
        });

        let lineTypes = this._getLineTypes();

        $('#' + this.lineTypeId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: lineTypes
        });

        $('#' + this.lineTypeId).data('kendoComboBox').value(lineTypes[0].id);

        $('#' + this.fillId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastPolygonFill = $('#' + this.fillId).data('kendoColorPicker').value()
            }
        });
        $('#' + this.strokeId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastPolygonStroke = $('#' + this.strokeId).data('kendoColorPicker').value()
            }
        });

        $('#' + this.eastingId).kendoNumericTextBox();
        $('#' + this.northingId).kendoNumericTextBox();

        $('#' + this.sizeId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.sizeId).data('kendoNumericTextBox').value(2);

        this._removeInteraction();

        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource(),
            type: 'Polygon',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Polygon');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawstart', (evt) => {
            this.currentFeature = evt.feature;
        });

        this.currentInteraction.on('drawend', (evt) => {
            evt.feature.set('showLength', true);
            evt.feature.set('showAngle', true);
            evt.feature.set('labelUnits', 'M');
            evt.feature.set('drawType', 'Polygon');
            evt.feature.set('lineType', $('#' + this.lineTypeId).data('kendoComboBox').value());
            evt.feature.set('strokeColor', $('#' + this.strokeId).data('kendoColorPicker').value());
            evt.feature.set('strokeSize', $('#' + this.sizeId).data('kendoNumericTextBox').value());
            evt.feature.set('fillColor', $('#' + this.fillId).data('kendoColorPicker').value());
            evt.feature.layerId = layerTypes.REDLINE;
            evt.feature.set('id', this.currentId);
            this.currentId++;

            let coordinates = evt.feature.getGeometry().getCoordinates()[0];
            coordinates = coordinates[coordinates.length - 1];

            $('#' + this.eastingId).data('kendoNumericTextBox').value(coordinates[0]);
            $('#' + this.northingId).data('kendoNumericTextBox').value(coordinates[1]);
        });

        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Polygon' }, this, this.mapControl.classId);

        $('#' + this.mapControl.mapElementId).on('click.polygon', this._handleClickOnMapPolygon.bind(this));
    }

    _startDrawLine() {
        $('#' + this.redlineOptionsId)[0].innerHTML = this._getLineOptions();

        $('#' + this.captureId).on('click', () => {
            let easting = $('#' + this.eastingId).data('kendoNumericTextBox').value();
            let northing = $('#' + this.northingId).data('kendoNumericTextBox').value();
            if (this.currentInteraction.sketchFeature_) {
                this._addPointToLine([easting, northing]);
                this.currentInteraction.sketchCoords_ = this.currentFeature.getGeometry().getCoordinates();
            } else {
                this.currentInteraction.startDrawing_([easting, northing]);
            }
        });

        $('#' + this.finishId).on('click', () => {
            this.currentInteraction.finishDrawing();
        });

        let lineTypes = this._getLineTypes();

        $('#' + this.lineTypeId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: lineTypes
        });

        $('#' + this.lineTypeId).data('kendoComboBox').value(lineTypes[0].id);

        $('#' + this.sizeId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.sizeId).data('kendoNumericTextBox').value(2);

        $('#' + this.eastingId).kendoNumericTextBox();
        $('#' + this.northingId).kendoNumericTextBox();

        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource(),
            type: 'LineString',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawstart', (evt) => {
            this.currentFeature = evt.feature; 
        });

        $('#' + this.colorId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastLineStroke = $('#' + this.colorId).data('kendoColorPicker').value()
            }
        });
        
        this.currentInteraction.on('drawend', (evt) => {
            evt.feature.set('showLength', true);
            evt.feature.set('showAngle', true);
            evt.feature.set('labelUnits', 'M');
            evt.feature.set('drawType', 'PolyLine');
            evt.feature.set('lineType', $('#' + this.lineTypeId).data('kendoComboBox').value());
            evt.feature.set('strokeColor', $('#' + this.colorId).data('kendoColorPicker').value());
            evt.feature.set('strokeSize', $('#' + this.sizeId).data('kendoNumericTextBox').value());
            evt.feature.layerId = layerTypes.REDLINE;
            evt.feature.set('id', this.currentId);
            this.currentId++;

            let coordinates = evt.feature.getGeometry().getCoordinates();
            coordinates = coordinates[coordinates.length - 1];

            $('#' + this.eastingId).data('kendoNumericTextBox').value(coordinates[0]);
            $('#' + this.northingId).data('kendoNumericTextBox').value(coordinates[1]);
        });

        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);

        $('#' + this.mapControl.mapElementId).on('click.line', this._handleClickOnMapLine.bind(this));
    }

    _addPointToPolygon(newPoint) {
        if (this.currentFeature) {
            const geometry = this.currentFeature.getGeometry();
            const coordinates = geometry.getCoordinates()[0];

            let size = coordinates.length;

            if (size == 2) {
                let coords = [];

                coords.push(coordinates[0]);
                coords.push(newPoint);
                coords.push(newPoint);
                coords.push(coordinates[0]);

                geometry.setCoordinates([coords]);
            } else {
                let coords = [];

                for (let i = 0; i < size - 2; i++) {
                    coords.push(coordinates[i]);
                }

                coords.push(newPoint);
                coords.push(newPoint);
                coords.push(coordinates[size - 1]);
                geometry.setCoordinates([coords]);
            }
        }
    }

    _addPointToLine(newPoint) {
        if (this.currentFeature) {
            const geometry = this.currentFeature.getGeometry();
            const coordinates = geometry.getCoordinates();

            let size = coordinates.length;

            if (coordinates[size - 2][0] == coordinates[size - 1][0] && coordinates[size - 2][1] == coordinates[size - 1][1]) {
                let coords = [];

                for (let i = 0; i < size - 2; i++) {
                    coords.push(coordinates[i]);
                }

                coords.push(coordinates[size - 1]);
                coords.push(newPoint);
                coords.push(newPoint);

                geometry.setCoordinates(coords);
            } else {
                let coords = [];

                for (let i = 0; i < size - 1; i++) {
                    coords.push(coordinates[i]);
                }

                coords.push(newPoint);
                coords.push(newPoint);
                geometry.setCoordinates(coords);
            }
        }
    }

    _handleClickOnMapPolygon(evt) {
        setTimeout(() => {
            if (evt.button == 0) {
                let currentInteraction = this.currentInteraction;
                if (currentInteraction.sketchFeature_) {
                    let coordinates = currentInteraction.sketchFeature_.getGeometry().getCoordinates()[0];

                    if (coordinates != null && coordinates.length >= 2) {
                        coordinates = coordinates[coordinates.length - 2];

                        $('#' + this.eastingId).data('kendoNumericTextBox').value(coordinates[0]);
                        $('#' + this.northingId).data('kendoNumericTextBox').value(coordinates[1]);
                    }
                }
            }
        }, 10);
    }

    _handleClickOnMapLine(evt) {
        setTimeout(() => {
            if (evt.button == 0) {
                let currentInteraction = this.currentInteraction;
                if (currentInteraction.sketchFeature_) {
                    let coordinates = currentInteraction.sketchFeature_.getGeometry().getCoordinates();

                    if (coordinates != null && coordinates.length >= 2) {
                        coordinates = coordinates[coordinates.length - 1];

                        $('#' + this.eastingId).data('kendoNumericTextBox').value(coordinates[0]);
                        $('#' + this.northingId).data('kendoNumericTextBox').value(coordinates[1]);
                    }
                }
            }
        }, 10);
    }

    _startDrawText() {
        $('#' + this.redlineOptionsId)[0].innerHTML = this._getTextOptions();

        $('#' + this.captureId).on('click', () => {
            let easting = $('#' + this.eastingId).data('kendoNumericTextBox').value();
            let northing = $('#' + this.northingId).data('kendoNumericTextBox').value();

            let feature = new Feature({ geometry: new Point([easting, northing]) });

            feature.set('showLength', true);
            feature.set('showAngle', true);
            feature.set('labelUnits', 'M');
            feature.set('drawType', 'Label');
            feature.set('textColor', $('#' + this.colorId).data('kendoColorPicker').value());
            feature.set('textSize', $('#' + this.textSizeId).data('kendoNumericTextBox').value());
            feature.set('haloColor', $('#' + this.haloColorId).data('kendoColorPicker').value());
            feature.set('haloSize', $('#' + this.haloSizeId).data('kendoNumericTextBox').value());
            feature.set('styleAngle', $('#' + this.angleId).data('kendoNumericTextBox').value());
            feature.set('text', $('#' + this.textId).val());
            this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource().addFeature(feature);
        });
        
        $('#' + this.colorId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastTextColor = $('#' + this.colorId).data('kendoColorPicker').value()
            }
        });

        $('#' + this.haloColorId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastTextHaloColor = $('#' + this.haloColorId).data('kendoColorPicker').value()
            }
        });

        $('#' + this.textSizeId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.haloSizeId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.textSizeId).data('kendoNumericTextBox').value(16);
        $('#' + this.haloSizeId).data('kendoNumericTextBox').value(2);

        $('#' + this.eastingId).kendoNumericTextBox();
        $('#' + this.northingId).kendoNumericTextBox();
        $('#' + this.angleId).kendoNumericTextBox();
        $('#' + this.angleId).data('kendoNumericTextBox').value(0);
        $('#' + this.textId).val(this.resourcesHandler.get('Text'));

        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource(),
            type: 'Point',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Label');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            evt.feature.set('showLength', true);
            evt.feature.set('showAngle', true);
            evt.feature.set('labelUnits', 'M');
            evt.feature.set('drawType', 'Label');
            evt.feature.set('textColor', $('#' + this.colorId).data('kendoColorPicker').value());
            evt.feature.set('textSize', $('#' + this.textSizeId).data('kendoNumericTextBox').value());
            evt.feature.set('haloColor', $('#' + this.haloColorId).data('kendoColorPicker').value());
            evt.feature.set('haloSize', $('#' + this.haloSizeId).data('kendoNumericTextBox').value());
            evt.feature.set('styleAngle', $('#' + this.angleId).data('kendoNumericTextBox').value());
            evt.feature.set('text', $('#' + this.textId).val());
            evt.feature.layerId = layerTypes.REDLINE;
            evt.feature.set('id', this.currentId);
            this.currentId++;

            let coordinates = evt.feature.getGeometry().getCoordinates();
            $('#' + this.eastingId).data('kendoNumericTextBox').value(coordinates[0]);
            $('#' + this.northingId).data('kendoNumericTextBox').value(coordinates[1]);
        });

        $('body').on('keydown.point', this._handleKeyDown.bind(this));
        $('body').on('keyup.point', this._handleKeyUp.bind(this));

        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Point' }, this, this.mapControl.classId);
    }

    _startDrawPoint() {
        $('#' + this.redlineOptionsId)[0].innerHTML = this._getPointOptions();

        $('#upload_' + this.imageUrlId).on('change', () => {
            let fileUpload = $('#upload_' + this.imageUrlId).get(0);
            let files = fileUpload.files;
            let formData = new FormData();
            formData.append(files[0].name, files[0]);

            $.ajax({
                type: "POST",
                url: rootURL + 'style/uploaduserfile',
                dataType: "json",
                data: formData,
                processData: false,
                contentType: false,
                success: function () {
                    $('#upload_' + this.imageUrlId).val(null);
                    $('#' + this.imageUrlId).data("kendoComboBox").dataSource.read();
                }
            });
        });

        $('#' + this.imageUrlId).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            let imagesUrl = this.rootURL + 'style/getuserimages?searchPattern=' + $('#' + this.imageUrlId).data('kendoComboBox').text();
                            return imagesUrl;
                        }
                    }
                }
            },
            template: (dataItem) => {
                let imgPath = dataItem.Attr[0].replaceAll('\\', '/');
                let name = dataItem.Name;

                return '<img src="' + imgPath + '" width="20" height="20" /><span class="k-state-default ml-2">' + name + '</span>';
            }
        });

        $('#' + this.captureId).on('click', () => {
            let easting = $('#' + this.eastingId).data('kendoNumericTextBox').value();
            let northing = $('#' + this.northingId).data('kendoNumericTextBox').value();

            let feature = new Feature({ geometry: new Point([easting, northing]) });

            feature.set('showLength', true);
            feature.set('showAngle', true);
            feature.set('labelUnits', 'M');
            feature.set('drawType', 'Point');
            feature.set('symbolType', $('#' + this.symbolTypeId).data('kendoComboBox').value());
            feature.set('fillColor', $('#' + this.fillId).data('kendoColorPicker').value());
            feature.set('strokeColor', $('#' + this.strokeId).data('kendoColorPicker').value());
            feature.set('styleSize', $('#' + this.sizeId).data('kendoNumericTextBox').value());
            feature.set('styleAngle', $('#' + this.angleId).data('kendoNumericTextBox').value());
            feature.layerId = layerTypes.REDLINE;
            feature.set('id', this.currentId);
            this.currentId++;
            this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource().addFeature(feature);
        });

        $('#' + this.fillId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastPointFill = $('#' + this.fillId).data('kendoColorPicker').value()
            }
        });
        $('#' + this.strokeId).kendoColorPicker({
            opacity: true,
            change: () => {
                this.lastPointStroke = $('#' + this.strokeId).data('kendoColorPicker').value()
            }
        });

        let symbolTypes = this._getSymbolTypes();

        $('#' + this.symbolTypeId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: symbolTypes,
            change: (evt) => {
                if (evt.sender.value() == 'IMAGE') {
                    $('#div_' + this.imageUrlId).show();
                } else {
                    $('#div_' + this.imageUrlId).hide();
                }
            }
        });

        $('#' + this.symbolTypeId).data('kendoComboBox').value(symbolTypes[0].id);

        $('#' + this.sizeId).kendoNumericTextBox({
            decimals: 0,
            format: '0'
        });

        $('#' + this.sizeId).data('kendoNumericTextBox').value(10);

        $('#' + this.eastingId).kendoNumericTextBox();
        $('#' + this.northingId).kendoNumericTextBox();
        $('#' + this.angleId).kendoNumericTextBox();
        $('#' + this.angleId).data('kendoNumericTextBox').value(0);

        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0].getSource(),
            type: 'Point',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Point');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            evt.feature.set('showLength', true);
            evt.feature.set('showAngle', true);
            evt.feature.set('labelUnits', 'M');
            evt.feature.set('drawType', 'Point');
            evt.feature.set('symbolType', $('#' + this.symbolTypeId).data('kendoComboBox').value());
            evt.feature.set('fillColor', $('#' + this.fillId).data('kendoColorPicker').value());
            evt.feature.set('strokeColor', $('#' + this.strokeId).data('kendoColorPicker').value());
            evt.feature.set('styleSize', $('#' + this.sizeId).data('kendoNumericTextBox').value());
            evt.feature.set('styleAngle', $('#' + this.angleId).data('kendoNumericTextBox').value());

            if ($('#' + this.symbolTypeId).data('kendoComboBox').value() == 'IMAGE') {
                let selectedImage = $('#' + this.imageUrlId).data('kendoComboBox').value();
                if (selectedImage != null && selectedImage.trim() != '') {
                    let selectedImageDesc = $('#' + this.imageUrlId).data('kendoComboBox').dataSource.data().find((x) => x.Name == selectedImage);
                    let imagePath = selectedImageDesc.Attr[0].replaceAll('\\', '/');
                    evt.feature.set('imagePath', imagePath);
                }
            }

            evt.feature.layerId = layerTypes.REDLINE;
            evt.feature.set('id', this.currentId);
            this.currentId++;

            let coordinates = evt.feature.getGeometry().getCoordinates();
            $('#' + this.eastingId).data('kendoNumericTextBox').value(coordinates[0]);
            $('#' + this.northingId).data('kendoNumericTextBox').value(coordinates[1]);
        });

        $('body').on('keydown.point', this._handleKeyDown.bind(this));
        $('body').on('keyup.point', this._handleKeyUp.bind(this));

        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Point' }, this, this.mapControl.classId);
    }

    _handleKeyDown(evt) {
        if (evt.originalEvent.keyCode == 16 && !this.shiftPressed) {
            this.shiftPressed = true;
            this.mapControl.map.getInteractions().forEach((interaction) => {
                if (interaction instanceof MouseWheelZoom) {
                    interaction.setActive(false);
                }
            });

            $('#' + this.mapControl.mapElementId).on('mousewheel.point', this._handlePointScroll.bind(this));
        }
    }

    _handleKeyUp(evt) {
        if (evt.originalEvent.keyCode == 16) {
            this.shiftPressed = false;
            this.mapControl.map.getInteractions().forEach((interaction) => {
                if (interaction instanceof MouseWheelZoom) {
                    interaction.setActive(true);
                }
            });

            $('#' + this.mapControl.mapElementId).off('mousewheel.point');
        }
    }

    _handlePointScroll(evt) {
        if (evt.originalEvent.wheelDelta / 120 > 0) {
            let initial = $('#' + this.angleId).data('kendoNumericTextBox').value();

            if (initial > 360) {
                $('#' + this.angleId).data('kendoNumericTextBox').value(0);
            } else {
                $('#' + this.angleId).data('kendoNumericTextBox').value(initial + 2);
            }
        }
        else {
            let initial = $('#' + this.angleId).data('kendoNumericTextBox').value();

            if (initial < 0) {
                $('#' + this.angleId).data('kendoNumericTextBox').value(360);
            } else {
                $('#' + this.angleId).data('kendoNumericTextBox').value(initial - 2);
            }
        }

        if (this.currentInteraction.sketchPoint_) {
            this.currentInteraction.sketchPoint_.changed();
        }
    }

    _getLineTypes() {
        return [
            {
                id: 'SOLID',
                name: this.resourcesHandler.get('Solid')
            }, {
                id: 'DOTTED',
                name: this.resourcesHandler.get('Dotted')
            }, {
                id: 'DASH_DOTTED',
                name: this.resourcesHandler.get('DashDotted')
            }
        ];
    }

    _getSymbolTypes() {
        return [
            {
                id: 'SQUARE',
                name: this.resourcesHandler.get('Square')
            }, {
                id: 'CIRCLE',
                name: this.resourcesHandler.get('Circle')
            }, {
                id: 'TRIANGLE',
                name: this.resourcesHandler.get('Triangle')
            }, {
                id: 'STAR',
                name: this.resourcesHandler.get('Star')
            }, {
                id: 'CROSS',
                name: this.resourcesHandler.get('Cross')
            }, {
                id: 'X',
                name: 'X'
            }, {
                id: 'IMAGE',
                name: 'IMAGE'
            }
        ];
    }

    _drawStyleFunction(feature, drawType) {
        let styles = [];
        let geometry = feature.getGeometry();
        let type = geometry.getType();
        let point, label, line, circleLine, pointLabel;

        if (drawType == 'Label') {
            let textLabel = new Style({
                text: new Text({
                    font: 'normal ' + $('#' + this.textSizeId).data('kendoNumericTextBox').value() + 'px Calibri,sans-serif',
                    fill: new Fill({
                        color: $('#' + this.colorId).data('kendoColorPicker').value(),
                    }),
                    backgroundFill: new Fill({
                        color: 'rgba(0, 0, 0, 0)',
                    }),
                    padding: [3, 3, 3, 3],
                    textBaseline: 'bottom',
                    offsetY: 0,
                    offsetX: 0,
                    stroke: new Stroke({
                        color: $('#' + this.haloColorId).data('kendoColorPicker').value(),
                        width: $('#' + this.haloSizeId).data('kendoNumericTextBox').value(),
                    }),
                    text: $('#' + this.textId).val(),
                    rotation: (Math.PI * ($('#' + this.angleId).data('kendoNumericTextBox').value() * 1)) / 180.0
                })
            });

            textLabel.setGeometry(geometry);

            styles.push(textLabel);

            return styles;
        }

        if (drawType == 'Point') {
            let symbolType = $('#' + this.symbolTypeId).data('kendoComboBox').value();
            let pointFillColor = $('#' + this.fillId).data('kendoColorPicker').value();
            let pointStrokeColor = $('#' + this.strokeId).data('kendoColorPicker').value();
            let pointSize = $('#' + this.sizeId).data('kendoNumericTextBox').value();
            let pointAngle = $('#' + this.angleId).data('kendoNumericTextBox').value();

            if (symbolType == 'IMAGE') {
                let selectedImage = $('#' + this.imageUrlId).data('kendoComboBox').value();
                if (selectedImage != null && selectedImage.trim() != '') {
                    let selectedImageDesc = $('#' + this.imageUrlId).data('kendoComboBox').dataSource.data().find((x) => x.Name == selectedImage);
                    let imagePath = selectedImageDesc.Attr[0].replaceAll('\\', '/');

                    let iconStyle = this._memoizeIcon(imagePath);

                    if (iconStyle != null) {
                        let clonedIcon = iconStyle.clone();
                        let imageSize = iconStyle.getImageSize();
                        let scale = pointSize / imageSize[0] || 1;
                        clonedIcon.setScale(scale);
                        clonedIcon.setRotation((Math.PI * (pointAngle * 1 + 45)) / 180.0);
                        styles.push(new Style({
                            image: clonedIcon,
                            geometry: geometry
                        }));
                    }
                }
            }

            if (symbolType == 'SQUARE') {
                styles.push(new Style({
                    image: new RegularShape({
                        fill: new Fill({ color: pointFillColor }),
                        stroke: new Stroke({ color: pointStrokeColor, width: 2 }),
                        points: 4,
                        radius: pointSize,
                        angle: (Math.PI * (pointAngle * 1 + 45)) / 180.0
                    }),
                    geometry: geometry
                }));
            }

            if (symbolType == 'CIRCLE') {
                styles.push(new Style({
                    image: new CircleStyle({
                        fill: new Fill({ color: pointFillColor }),
                        stroke: new Stroke({ color: pointStrokeColor, width: 2 }),
                        radius: pointSize
                    }),
                    geometry: geometry
                }));
            }

            if (symbolType == 'TRIANGLE') {
                styles.push(new Style({
                    image: new RegularShape({
                        fill: new Fill({ color: pointFillColor }),
                        stroke: new Stroke({ color: pointStrokeColor, width: 2 }),
                        points: 3,
                        radius: pointSize,
                        angle: (Math.PI * (pointAngle * 1)) / 180.0
                    }),
                    geometry: geometry
                }));
            }

            if (symbolType == 'STAR') {
                styles.push(new Style({
                    image: new RegularShape({
                        fill: new Fill({ color: pointFillColor }),
                        stroke: new Stroke({ color: pointStrokeColor, width: 2 }),
                        points: 5,
                        radius: pointSize,
                        radius2: pointSize / 2 - 1,
                        angle: (Math.PI * (pointAngle * 1)) / 180.0
                    }),
                    geometry: geometry
                }));
            }

            if (symbolType == 'CROSS') {
                styles.push(new Style({
                    image: new RegularShape({
                        fill: new Fill({ color: pointFillColor }),
                        stroke: new Stroke({ color: pointStrokeColor, width: 2 }),
                        points: 4,
                        radius: pointSize,
                        radius2: 0,
                        angle: (Math.PI * (pointAngle * 1)) / 180.0
                    }),
                    geometry: geometry
                }));
            }

            if (symbolType == 'X') {
                styles.push(new Style({
                    image: new RegularShape({
                        fill: new Fill({ color: pointFillColor }),
                        stroke: new Stroke({ color: pointStrokeColor, width: 2 }),
                        points: 4,
                        radius: pointSize,
                        radius2: 0,
                        angle: (Math.PI * (pointAngle * 1 + 45)) / 180.0
                    }),
                    geometry: geometry
                }));
            }
        }

        if (!drawType || drawType === type || type === 'Point') {
            let allStyle = this.drawMeasureStyle.clone();
            if (drawType == 'Circle' || drawType == 'Polygon') {
                allStyle.getFill().setColor('rgba(0, 0, 0, 0)');
            }

            if (type != 'Point') {
                styles.push(new Style({
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 255, 1)',
                        width: 5,
                    })
                }));

                styles.push(allStyle);
            }

            if (type === 'Polygon') {
                point = geometry.getInteriorPoint();
                label = this._formatArea(feature, geometry);
                if (geometry.getCoordinates()[0].length > 2) {
                    line = new LineString([geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 3], geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 2]]);
                }
            } else if (type === 'LineString') {
                point = new Point(geometry.getLastCoordinate());
                label = this._formatLength(feature, getLength(geometry));
                pointLabel = this._formatCoordinates(feature, point);
                line = geometry;
            } else if (drawType == 'Circle' && type != 'Point') {
                point = new Point(geometry.getCenter());
                label = this._formatCircleArea(feature, geometry);

                let secondPoint = geometry.getCenter();
                secondPoint[0] += geometry.getRadius();
                circleLine = new LineString([geometry.getCenter(), secondPoint]);
            } else if (drawType == 'Point' || (type == 'Point' && drawType != 'Point')) {
                point = new Point(geometry.getCoordinates());
                label = this._formatCoordinates(feature, geometry);
            }
        }

        let lastSegmentAngle;
        let perimeterLabel;
        let perimeter;
        let cursorPoint;

        if (line) {
            line.forEachSegment((a, b) => {
                let segment = new LineString([a, b]);
                let angle = this._formatAngle(feature, segment);
                lastSegmentAngle = this.drawLabelStyle.clone();
                cursorPoint = new Point(segment.getLastCoordinate());
                lastSegmentAngle.setGeometry(cursorPoint);
                lastSegmentAngle.getText().setText(angle);

                if (type == 'Polygon') {
                    lastSegmentAngle.getText().setOffsetY(27);
                } else {
                    lastSegmentAngle.getText().setOffsetY(40);
                }
            });
        }

        if (type == 'Polygon') {
            let points = feature.getGeometry().getCoordinates()[0];
            perimeter = 0;

            for (let i = 1; i < points.length; i++) {
                let segment = new LineString([points[i - 1], points[i]]);
                perimeter += getLength(segment);

                perimeterLabel = this.drawLabelStyle.clone();
                perimeterLabel.setGeometry(geometry.getInteriorPoint());
                perimeterLabel.getText().setText(this._formatLength(feature, perimeter));
                perimeterLabel.getText().setOffsetY(10);
            }
        }

        if (label) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(label);

            if (pointLabel) {
                clone.getText().setOffsetY(27);
            }

            styles.push(clone);
        }

        if (pointLabel) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(pointLabel);

            styles.push(clone);
        }

        if (lastSegmentAngle) {
            styles.push(lastSegmentAngle);
        }

        if (perimeterLabel) {
            styles.push(perimeterLabel);
        }

        return styles;
    }

    _formatAngle(feature, geometry) {
        return Math.round(this._getRotation(geometry) * 1000) / 1000 + ' °';
    }

    _getRotation(geometry) {
        let coords = geometry.getCoordinates();

        let first = coords[0];
        let last = coords[1];
        let rotation = -Math.atan2((last[1] - first[1]), (last[0] - first[0]));
        rotation = rotation * (180 / Math.PI);

        if (rotation < 0) {
            rotation = 360 + rotation;
        }

        rotation += 90;

        if (rotation > 360) {
            rotation -= 360;
        }

        return rotation;
    }

    _formatCoordinates(feature, geometry) {
        let coordinates = geometry.getCoordinates();
        return Math.round(coordinates[0] * 1000) / 1000 + ' \n ' + Math.round(coordinates[1] * 1000) / 1000;
    }

    _formatLength(feature, length) {
        let output = Math.round(length * 100) / 100 + ' m';

        return output;
    }

    _formatArea(feature, polygon) {
        let area = getArea(polygon);
        let output = Math.round(area * 100) / 100 + ' m\xB2';
        return output;
    }

    _formatCircleArea(feature, circle) {
        let radius = circle.getRadius();
        let area = Math.PI * Math.pow(radius, 2);
        let output = Math.round(area * 100) / 100 + ' m\xB2';
        
        return output;
    }

    _removeInteraction() {
        if (this.currentInteraction != null) {
            this.mapControl.map.removeInteraction(this.currentInteraction);
            this.currentInteraction = null;
        }

        $('body').off('keydown.point');
        $('body').off('keyup.point');
        $('#' + this.mapControl.mapElementId).off('click.line');
        $('#' + this.mapControl.mapElementId).off('click.polygon');

        $event.notify(eventTypes.STOP_SNAP, {}, this, this.mapControl.classId);
        this.deleteEnabled = false;
    }

    _addRedlineLayer() {
        this.layerAdded = true;
        this.mapControl.addTemporaryVectorLayer({
            name: layerTypes.REDLINE,
            geometryType: geomTypes.GEOM_ALL,
            srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
            geomField: 'geom',
            idField: 'id',
            visible: true,
            displayName: this.resourcesHandler.get('RedlineResults'),
            ignoreStyle: true,
            addToLegend: true,
            parentId: layerTypes.INTERACTION_TOOLS,
            parentDisplayName: this.resourcesHandler.get('UserInteractionResults'),
            showLegend: false,
            declutter: false,
            selectable: true
        }).then(() => {
            let layer = this.mapControl.layerHandler.getLayerById(layerTypes.REDLINE)[0];
            layer.setStyle((feature) => {
                return this._styleFunction(feature, feature.get('drawType'));
            });
        });
    }

    _styleFunction(feature, drawType) {
        switch (drawType) {
            case 'Point': return this._getPointStyle(feature);
            case 'Label': return this._getLabelStyle(feature);
            case 'PolyLine': return this._getPolyLineStyle(feature);
            case 'Polygon': return this._getPolygonStyle(feature);
            case 'Square': return this._getPolygonStyle(feature);
            case 'Circle': return this._getPolygonStyle(feature);
            default: return [];
        }
    }

    _getPolygonStyle(feature) {
        let styles = [];

        if (feature.get('xstate') == 5) {
            return styles;
        }

        let lineType = feature.get('lineType');

        let isSelected = feature.get('xstate') == styleTypes.SELECT_STYLE_TYPE || feature.get('xstate') == styleTypes.HOVER_STYLE_TYPE;

        let fillColor = feature.get('fillColor');
        let strokeColor = feature.get('strokeColor');

        if (isSelected) {
            fillColor = 'rgba(0, 255, 12, 0.3)';
            strokeColor = 'rgba(0, 255, 12, 1)';
        }

        let stroke = new Stroke({
            color: strokeColor,
            width: feature.get('strokeSize'),
        });

        let fill = new Fill({
            color: fillColor
        });

        if (lineType == 'DASH_DOTTED') {
            stroke.setLineDash([10, 10, 0, 10]);
        } else if (lineType == 'DOTTED') {
            stroke.setLineDash([10, 10]);
        }

        let lineStyle = new Style({
            stroke: stroke,
            fill: fill
        });

        styles.push(lineStyle);

        return styles;
    }

    _getPolyLineStyle(feature) {
        let styles = [];

        let isSelected = feature.get('xstate') == styleTypes.SELECT_STYLE_TYPE || feature.get('xstate') == styleTypes.HOVER_STYLE_TYPE;
        let strokeColor = feature.get('strokeColor');

        if (isSelected) {
            strokeColor = 'rgba(0, 255, 12, 1)';
        }

        let lineType = feature.get('lineType');

        let stroke = new Stroke({
            color: strokeColor,
            width: feature.get('strokeSize'),
        });

        if (lineType == 'DASH_DOTTED') {
            stroke.setLineDash([10, 10, 0, 10]);
        } else if (lineType == 'DOTTED') {
            stroke.setLineDash([10, 10]);
        }

        let lineStyle = new Style({
            stroke: stroke
        });

        styles.push(lineStyle);

        return styles;
    }

    _getLabelStyle(feature) {
        let styles = [];

        let isSelected = feature.get('xstate') == styleTypes.SELECT_STYLE_TYPE || feature.get('xstate') == styleTypes.HOVER_STYLE_TYPE;

        let textColor = feature.get('textColor');
        let haloColor = feature.get('haloColor');

        if (isSelected) {
            textColor = 'rgba(0, 255, 12, 1)';
            haloColor = 'rgba(255, 255, 255, 1)';
        }

        let textLabel = new Style({
            text: new Text({
                font: 'normal ' + feature.get('textSize') + 'px Calibri,sans-serif',
                fill: new Fill({
                    color: textColor,
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: 0,
                offsetX: 0,
                stroke: new Stroke({
                    color: haloColor,
                    width: feature.get('haloSize'),
                }),
                text: feature.get('text'),
                rotation: (Math.PI * (feature.get('styleAngle') * 1)) / 180.0
            }),
            geometry: feature.getGeometry()
        });

        styles.push(textLabel);

        return styles;
    }

    _getPointStyle(feature) {
        let styles = [];

        let isSelected = feature.get('xstate') == styleTypes.SELECT_STYLE_TYPE || feature.get('xstate') == styleTypes.HOVER_STYLE_TYPE;

        let fillColor = feature.get('fillColor');
        let strokeColor = feature.get('strokeColor');

        if (isSelected) {
            fillColor = 'rgba(0, 255, 12, 0.3)';
            strokeColor = 'rgba(0, 255, 12, 1)';
        }

        if (feature.get('symbolType') == 'IMAGE') {
            let imagePath = feature.get('imagePath')
            let iconStyle = this._memoizeIcon(imagePath);

            if (iconStyle != null) {
                let clonedIcon = iconStyle.clone();
                let imageSize = iconStyle.getImageSize();
                let scale = feature.get('styleSize') / imageSize[0] || 1;
                clonedIcon.setScale(scale);
                clonedIcon.setRotation((Math.PI * (feature.get('styleAngle') * 1 + 45)) / 180.0);
                styles.push(new Style({
                    image: clonedIcon,
                    geometry: feature.getGeometry()
                }));
            }
        }

        if (feature.get('symbolType') == 'SQUARE') {
            styles.push(new Style({
                image: new RegularShape({
                    fill: new Fill({ color: fillColor }),
                    stroke: new Stroke({ color: strokeColor, width: 2 }),
                    points: 4,
                    radius: feature.get('styleSize'),
                    angle: (Math.PI * (feature.get('styleAngle') * 1 + 45)) / 180.0
                }),
                geometry: feature.getGeometry()
            }));
        }

        if (feature.get('symbolType') == 'CIRCLE') {
            styles.push(new Style({
                image: new CircleStyle({
                    fill: new Fill({ color: fillColor }),
                    stroke: new Stroke({ color: strokeColor, width: 2 }),
                    radius: feature.get('styleSize')
                }),
                geometry: feature.getGeometry()
            }));
        }

        if (feature.get('symbolType') == 'TRIANGLE') {
            styles.push(new Style({
                image: new RegularShape({
                    fill: new Fill({ color: fillColor }),
                    stroke: new Stroke({ color: strokeColor, width: 2 }),
                    points: 3,
                    radius: feature.get('styleSize'),
                    angle: (Math.PI * (feature.get('styleAngle') * 1)) / 180.0
                }),
                geometry: feature.getGeometry()
            }));
        }

        if (feature.get('symbolType') == 'STAR') {
            styles.push(new Style({
                image: new RegularShape({
                    fill: new Fill({ color: fillColor }),
                    stroke: new Stroke({ color: strokeColor, width: 2 }),
                    points: 5,
                    radius: feature.get('styleSize'),
                    radius2: feature.get('styleSize') / 2 - 1,
                    angle: (Math.PI * (feature.get('styleAngle') * 1)) / 180.0
                }),
                geometry: feature.getGeometry()
            }));
        }

        if (feature.get('symbolType') == 'CROSS') {
            styles.push(new Style({
                image: new RegularShape({
                    fill: new Fill({ color: fillColor }),
                    stroke: new Stroke({ color: strokeColor, width: 2 }),
                    points: 4,
                    radius: feature.get('styleSize'),
                    radius2: 0,
                    angle: (Math.PI * (feature.get('styleAngle') * 1)) / 180.0
                }),
                geometry: feature.getGeometry()
            }));
        }

        if (feature.get('symbolType') == 'X') {
            styles.push(new Style({
                image: new RegularShape({
                    fill: new Fill({ color: fillColor }),
                    stroke: new Stroke({ color: strokeColor, width: 2 }),
                    points: 4,
                    radius: feature.get('styleSize'),
                    radius2: 0,
                    angle: (Math.PI * (feature.get('styleAngle') * 1 + 45)) / 180.0
                }),
                geometry: feature.getGeometry()
            }));
        }

        return styles;
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getToolbarTemplate() {
        return `<div class="feature-toolbar-content">
                    <div title="` + this.resourcesHandler.get('DrawPoint') + `" class="feature-toolbar-button fal fa-crosshairs" id="` + this.drawPointId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('DrawText') + `" class="feature-toolbar-button fal fa-text-size" id="` + this.drawTextId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('DrawPolyLine') + `" class="feature-toolbar-button ni ni-graph" id="` + this.drawLineId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('DrawPolygon') + `" class="feature-toolbar-button fal fa-draw-polygon" id="` + this.drawPolygonId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('DrawSquare') + `" class="feature-toolbar-button fal fa-draw-square" id="` + this.drawSquareId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('DrawCircle') + `" class="feature-toolbar-button fal fa-draw-circle" id="` + this.drawCircleId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('RemoveRedline') + `" class="feature-toolbar-button fal fa-comment-times" id="` + this.deleteRedlineId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('RemoveAllRedlines') + `" class="feature-toolbar-button fal fa-trash-alt" id="` + this.deleteAllRedlinesId + `">
                    </div>
                </div>
                <div class="feature-toolbar-extra-content" id="` + this.redlineOptionsId + `">
                </div>`;
    }

    _getCircleOptions() {
        return `<div class="col-12 mb-3 mt-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('RedlineStyle') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('LineType') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.lineTypeId + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Stroke') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.strokeId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastCircleStroke + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('StrokeSize') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.sizeId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Fill') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control col-12" id="` + this.fillId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastCircleFill + `">
                        </div>
                    </div>
                </div>`;
    }

    _getSquareOptions() {
        return `<div class="col-12 mb-3 mt-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('RedlineStyle') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('LineType') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.lineTypeId + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Stroke') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.strokeId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastSquareStroke + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('StrokeSize') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.sizeId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Fill') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control col-12" id="` + this.fillId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastSquareFill + `">
                        </div>
                    </div>
                </div>`;
    }

    _getPolygonOptions() {
        return `<div class="col-12 mb-3 mt-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('RedlineStyle') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('LineType') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.lineTypeId + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Stroke') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.strokeId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastPolygonStroke + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('StrokeSize') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.sizeId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Fill') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control col-12" id="` + this.fillId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastPolygonFill + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3" style="border-bottom: 1px solid;"></div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('Capture') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Easting') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.eastingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Northing') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.northingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-end">
                        <button class="btn btn-primary" id="` + this.captureId + `">` + this.resourcesHandler.get('Add') + `</button>
                        <button class="btn btn-primary ml-2" id="` + this.finishId + `">` + this.resourcesHandler.get('Finish') + `</button>
                    </div>
                </div>`;
    }

    _getLineOptions() {
        return `<div class="col-12 mb-3 mt-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('RedlineStyle') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('LineType') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.lineTypeId + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Color') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.colorId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastLineStroke + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Size') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.sizeId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3" style="border-bottom: 1px solid;"></div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('Capture') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Easting') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.eastingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Northing') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.northingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-end">
                        <button class="btn btn-primary" id="` + this.captureId + `">` + this.resourcesHandler.get('Add') + `</button>
                        <button class="btn btn-primary ml-2" id="` + this.finishId + `">` + this.resourcesHandler.get('Finish') + `</button>
                    </div>
                </div>`;
    }

    _getTextOptions() {
        return `<div class="col-12 mb-3 mt-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('RedlineStyle') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Color') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.colorId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastTextColor + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('TextSize') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.textSizeId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('HaloColor') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.haloColorId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastTextHaloColor + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('HaloSize') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.haloSizeId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3" style="border-bottom: 1px solid;"></div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('Capture') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Text') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.textId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Easting') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.eastingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Northing') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.northingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Angle') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.angleId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-end">
                        <button class="btn btn-primary" id="` + this.captureId + `">` + this.resourcesHandler.get('Add') + `</button>
                    </div>
                </div>`;
    }

    _getPointOptions() {
        return `<div class="col-12 mb-3 mt-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('RedlineStyle') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('SymbolType') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.symbolTypeId + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3" id="div_` + this.imageUrlId + `" style="display: none;">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('ImageUrl') + `:</label>
                        </div>
                        <div class="col-6 pr-0 pl-0">
                            <input class="form-control" id="` + this.imageUrlId + `">
                        </div>
                        <div class="col-2 col-2">
                            <label style="display: flex; justify-content:center; align-items: center; width: 43px; cursor: pointer;">
                                <i class="fal fa-upload"></i>
                                <input type="file" id="upload_` + this.imageUrlId + `" accept="image/*" style="display: none;" />
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Fill') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.fillId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastPointFill + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Stroke') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.strokeId + `" type="color" style="padding: 0.3rem 0.5rem;" value="` + this.lastPointStroke + `">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Size') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.sizeId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3" style="border-bottom: 1px solid;"></div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-center">
                        <label style="font-weight: bold;">` + this.resourcesHandler.get('Capture') + `</label>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Easting') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.eastingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Northing') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.northingId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex">
                        <div class="col-4 align-content-center pl-0">
                            <label>` + this.resourcesHandler.get('Angle') + `:</label>
                        </div>
                        <div class="col-8 pr-0 pl-0">
                            <input class="form-control" id="` + this.angleId + `" type="text">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="form-group d-flex justify-content-end">
                        <button class="btn btn-primary" id="` + this.captureId + `">` + this.resourcesHandler.get('Add') + `</button>
                    </div>
                </div>`;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}